import { render, staticRenderFns } from "./_LiveData.vue?vue&type=template&id=94e98180&scoped=true&"
import script from "./_LiveData.vue?vue&type=script&lang=js&"
export * from "./_LiveData.vue?vue&type=script&lang=js&"
import style0 from "./_LiveData.vue?vue&type=style&index=0&id=94e98180&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e98180",
  null
  
)

export default component.exports